module.exports = __webpack_public_path__ + "static/media/pt-PT.d851afdc.md";